module.exports = __webpack_public_path__ + "img/Mode_Selector_KingRestRoyal.87d6fb5d.png";